import { Container, Typography } from "components/ct-design";
import SRPSideSheet from "./srpSideSheet";
import { FunctionComponent } from "react";
import { BusInfoProps } from "./types";

const BusInfo: FunctionComponent<BusInfoProps> = (props) => {
  const {
    solutionId,
    busIndex,
    showSideSheet,
    setShowSideSheet,
    selectedTab,
    setSelectedTab,
    handleSideSheet,
  } = props;
  return (
    <>
      {showSideSheet ? (
        <SRPSideSheet
          onClose={() =>
            setTimeout(() => {
              setShowSideSheet(false);
            }, 200)
          }
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          busIndex={busIndex}
          solutionId={solutionId}
        />
      ) : null}
      <Container className="flex flex-middle">
        <Typography
          variant="L2"
          color="link"
          className="c-pointer"
          onClick={() => handleSideSheet("0")}
          isClickable
        >
          Amenities
        </Typography>
        <Typography
          variant="L2"
          colorCode="#0F6BFF"
          className="c-pointer"
          onClick={() => handleSideSheet("1")}
          isClickable
        >
          <span className="mx-1 c-disabled">·</span>Cancellation policy
        </Typography>
        <Typography
          variant="L2"
          colorCode="#0F6BFF"
          className="c-pointer"
          onClick={() => handleSideSheet("2")}
          isClickable
        >
          <span className="mx-1 c-disabled">·</span>Ratings
        </Typography>
      </Container>
    </>
  );
};

export default BusInfo;
